/**
@format
@flow
*/
import React from 'react';
import styled from 'styled-components';
import ListItem from '@ziynx/components/listItems';
import Colors from '@ziynx/theme/colors';
import Link from '@ziynx/components/links';
import { Body } from '@ziynx/components/typography';
import { withAppManager } from '@ziynx/components/utilities';
import type { RightActionType, CardInfoType } from '@ziynx/flow-types/globals';
import type { ManagedProps } from '@ziynx/flow-types/appManager';
import CardBase from './CardBase';

export type Props = $ReadOnly<{|
  /**
   * Data object
   */
  data: Array<CardInfoType>,
  /**
   * Right side action
   */
  rightAction?: RightActionType,

|}>;

const ComponentWrapper = styled.div`
  max-width: 688px;
`;

const StyledListItem = styled(ListItem)`
  padding-bottom: ${({ lastItem }) => (lastItem ? 0 : 24)}px;
`;

const ListWrapper = styled.div`
`;

const StyledCard = styled(CardBase)`
  flex-direction: row;
  justify-content: space-between;
`;

const CardInfo = (props: ManagedProps<Props>): React$Node => {
  const { data, rightAction } = props;

  const renderData = (arr: Array<CardInfoType>): React$Node => {
    if (!arr.length) return null;
    const lastItem = arr.length - 1;
    return arr.map((item: CardInfoType, index: number): React$Node => {
      const {
        icon, label, text,
      } = item;

      return (
        <StyledListItem
          key={index}
          variant="icon"
          icon={{ name: icon }}
          label={{ text: label, labelPosition: 'top' }}
          text={text}
          lastItem={index === lastItem}
        />
      );
    });
  };

  return (
    <ComponentWrapper>
      <StyledCard width="initial">
        <ListWrapper>
          {renderData(data)}
        </ListWrapper>
        <Body medium>
          {rightAction && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
              variant="text"
              large
              color={Colors.PrimaryBlue}
              onClick={rightAction?.onClick}
            >
              Edit
            </Link>
          )}
        </Body>
      </StyledCard>
    </ComponentWrapper>
  );
};

export default (withAppManager(CardInfo): React$ComponentType<ManagedProps<Props>>);
